import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NewAudit from './views/NewAudit.vue'
import Audit from './views/Audit.vue'
import NewCatalogue from './views/NewCatalogue.vue'
import Catalogue from './views/Catalogue.vue'
import PerformAudit from './views/PerformAudit.vue'
import ReportAudit from './views/ReportAudit.vue'
import NewProcess from './views/kb/NewProcess.vue'
import EditProcess from './views/kb/EditProcess.vue'
import ProcessDetail from './views/kb/ProcessDetail.vue'
import KnowledgeBase from './views/KnowledgeBase.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/audit',
      name: 'audit',
      component: NewAudit
    },
    {
      path: '/audit/:audit_id',
      component: Audit
    },
    {
      path: '/catalogue/new',
      component: NewCatalogue
    },
    {
      path: '/catalogue/:questionnaire_catalogue_id/edit',
      component: Catalogue
    },
    {
      path: '/audit/:audit_id/perform',
      component: PerformAudit
    },
    {
      path: '/audit/:audit_id/report',
      component: ReportAudit
    },
    {
      path: '/kb/1',
      component: KnowledgeBase
    },
    {
      path: '/kb/process/new',
      component: NewProcess
    },
    {
      path: '/kb/1/process/:knowledge_process_id/edit',
      component: EditProcess
    },
    {
      path: '/kb/1/process/:knowledge_process_id/detail',
      component: ProcessDetail
    }
  ]
})
